import React, { useState, useRef, useLayoutEffect } from "react";
import { createPortal } from "react-dom";

export default function Tooltip({ content, children, offset = 8 }) {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const anchorRef = useRef(null);
  const tipRef = useRef(null);

  useLayoutEffect(() => {
    if (!open) return;
    const update = () => {
      const r = anchorRef.current?.getBoundingClientRect();
      const t = tipRef.current;
      if (!r || !t) return;
      let top = r.top - offset - t.offsetHeight;                  // above
      let left = r.left + r.width / 2 - t.offsetWidth / 2;        // centered
      const pad = 8;
      left = Math.max(pad, Math.min(left, window.innerWidth - t.offsetWidth - pad));
      if (top < pad) top = r.bottom + offset;                     // flip below if needed
      setPos({ top, left });
    };
    update();
    const onResize = () => update();
    window.addEventListener("resize", onResize);
    document.addEventListener("scroll", onResize, true);          // capture scrolls in any container
    return () => {
      window.removeEventListener("resize", onResize);
      document.removeEventListener("scroll", onResize, true);
    };
  }, [open, offset]);

  const child = React.cloneElement(children, {
    ref: anchorRef,
    onMouseEnter: (e) => { setOpen(true); children.props.onMouseEnter?.(e); },
    onMouseLeave: (e) => { setOpen(false); children.props.onMouseLeave?.(e); },
    onFocus:      (e) => { setOpen(true); children.props.onFocus?.(e); },
    onBlur:       (e) => { setOpen(false); children.props.onBlur?.(e); },
  });

  return (
    <>
      {child}
      {open && createPortal(
        <div ref={tipRef} className="tooltip-floating" style={{ top: pos.top, left: pos.left }}>
          {content}
        </div>,
        document.body
      )}
    </>
  );
}
